import { string, shape, bool } from "prop-types";

const propTypes = {
  quoteText: string,
  firstName: string,
  lastName: string,
  program: string,
  classYear: string,
  image: shape({
    mobile1X: string.isRequired,
    desktop1X: string.isRequired,
    mobile2X: string.isRequired,
    desktop2X: string.isRequired,
  }),
  imageText: string,
  imageIcon: bool,
};

const Quote = (props) => {
  const {
    quoteText,
    firstName,
    lastName,
    program,
    classYear,
    image,
    imageText,
    imageIcon,
  } = props;

  return (
    <figure className="testimonials-quote">
      <div className="testimonials-quote__text-wrapper">
        <blockquote>
          <div dangerouslySetInnerHTML={{ __html: quoteText }}></div>
        </blockquote>
        <figcaption>
          <cite>
            <div className="testimonials-quote__name">
              {firstName} {lastName} {classYear}
            </div>
            <div className="testimonials-quote__program">{program}</div>
          </cite>
        </figcaption>
      </div>
      <div className="testimonials-quote__image-wrapper">
        <div className="testimonials-quote__image-decoration">
          {imageText && imageText !== "" && (
            <div className="testimonials-quote__image-text">
              <div dangerouslySetInnerHTML={{ __html: imageText }}></div>
            </div>
          )}
          {imageIcon && <div className="testimonials-quote__camera-icon"></div>}
          <img
            srcSet={`
             ${image.mobile1X} 344w,
             ${image.desktop1X} 528w,
             ${image.mobile2X} 688w,
             ${image.desktop2X} 1056w
           `}
            sizes="
              100%
            "
            src={image.mobile1X}
            alt=""
            loading="lazy"
          />
        </div>
      </div>
    </figure>
  );
};

Quote.propTypes = propTypes;
export default Quote;
